import React, { Component } from 'react';
import PropTypes from 'prop-types';
import AOS from 'aos';
import 'aos/dist/aos.css';
import Layout from '../components/layout'
import Footer from '../components/Footer/Footer';
import { replaceStoreLink, redirectToStore } from '../helpers/mobileRedirect';

import styles from './index.module.scss';
import imgHeroProduct from './images/img-hero-product.png';
import imgAppIcon from './images/img-appicon.png';
import imgAppStore from './images/btn-appstore-n.png';
import imgPlayStore from './images/btn-playstore-n.png';

class IndexPage extends Component {
  static contextTypes = {
    language: PropTypes.object,
  };

  componentDidMount() {
    replaceStoreLink()
    // redirectToStore();

    AOS.init({
      delay: 800,
      duration: 1500,
      once: true,
      startEvent: 'load',
      disable: 'mobile',
    })
  }

  UNSAFE_componentWillReceiveProps() {
    AOS.refresh()
  }

  render() {
    return <Layout>
        <header className={styles.header}>
          <a href="javascript:;" className={styles.logo}>
            <h1>前端找工作</h1>
          </a>

          <div className={styles.headline}>
            <div className={styles.overlap}>
              <h1 className={styles.siteName}>前端找工作</h1>
              <h2 className={styles.title}>
                匯集多個台灣的前端工程師職缺來源
              </h2>
            </div>

            <h3 className={styles.subTitle}>
              免去往返多個求職平台查閱的繁複過程，讓你隨時隨地掌握最新前端職缺訊息
            </h3>

            <div className={styles.quickDownload}>
              <a href="https://itunes.apple.com/tw/app/前端找工作/id1444386377?mt=8" target="_blank" rel="noopener noreferrer" className={styles.dlAppStore} data-store="appstore">
                App Store
              </a>
              <a href="https://play.google.com/store/apps/details?id=me.patw.f2efindjobs" target="_blank" rel="noopener noreferrer" className={styles.dlGooglePlay} data-store="googleplay">
                Google play
              </a>
            </div>
          </div>

          <img data-aos="fade-right" data-aos-delay="50" src={imgHeroProduct} className={styles.kv} />
        </header>

        <article className={styles.promotion}>
          <a className={styles.dlF2EFindJobs}>前端找工作</a>

          <h1>前端找工作 App</h1>

          <h2>免去往返多個求職平台查閱的繁複過程，讓你隨時隨地掌握最新前端職缺訊息</h2>

          <a href="https://itunes.apple.com/tw/app/前端找工作/id1444386377?mt=8" target="_blank" rel="noopener noreferrer" className={styles.dlAppStore} data-store="appstore">
            App Store
          </a>
          <a href="https://play.google.com/store/apps/details?id=me.patw.f2efindjobs" target="_blank" rel="noopener noreferrer" className={styles.dlGooglePlay} data-store="googleplay">
            Google play
          </a>

          <fieldset className={styles.donate}>
            <legend><h3>贊助</h3></legend>

            <form className={styles.paypalDonate} action="https://www.paypal.com/cgi-bin/webscr" method="post" target="_top">
              <input type="hidden" name="cmd" value="_s-xclick" />
              <input type="hidden" name="hosted_button_id" value="PU2Z6LV4VNEEC" />
              <input type="image" src="https://www.paypalobjects.com/en_US/TW/i/btn/btn_donateCC_LG.gif" border="0" name="submit" title="PayPal - The safer, easier way to pay online!" alt="Donate with PayPal button" />
              <img alt="" border="0" src="https://www.paypal.com/en_TW/i/scr/pixel.gif" width="1" height="1" />
            </form>

            <div className={styles.ecpayDonate}>
              <a href="https://p.ecpay.com.tw/B6476">
                透過 ECPay 贊助
              </a>
            </div>
          </fieldset>
        </article>

        <Footer />
      </Layout>
  }
};

export default IndexPage;



// WEBPACK FOOTER //
// ./src/pages/index.js